import { useEkardoLazyQuery } from '@netfront/ekardo-content-library';

import {
  IGetProgressQueryGraphQLResponse,
  IGetProgressQueryVariables,
  IHandleGetProgressParams,
  IUseGetProgress,
  IUseGetProgressOptions,
} from './useGetProgress.interfaces';
import { GET_PROGRESS } from './useGetProgress.graphql';

const useGetProgress = (options?: IUseGetProgressOptions): IUseGetProgress => {
  const { fetchPolicy, onCompleted, onError, query, tokens } = options ?? ({} as IUseGetProgressOptions);

  const [executeGetProgressTracking, { loading: isLoading }] = useEkardoLazyQuery<IGetProgressQueryGraphQLResponse, IGetProgressQueryVariables>({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          userFlow: {
            getProgress: progressTrackings,
          },
        } = data;

        void onCompleted({ progressTrackings });
      },
      onError,
    },
    query: query ?? GET_PROGRESS,
    tokens,
  });

  const handleGetProgress = ({ usersId, userFlowId }: IHandleGetProgressParams) => {
    void executeGetProgressTracking({
      variables: {
        usersId,
        userFlowId
      },
    });
  };

  return {
    handleGetProgress,
    isLoading,
  };
};

export { useGetProgress };
